import React, { useState, useEffect } from "react";

import ImageSlider from "./file-slider";
import { generateFilePreview } from "../file-functions";

export default ({ uploadedFiles, cssClass = "", ...props }) => {

    const [generatedFiles, setGeneratedFiles] = useState([]);

    useEffect(() => {
        if (uploadedFiles) {
            (async () => {
                const tempUploadedFiles = [];
                
                for (const inputFile of uploadedFiles) {
                    const [url, message] = await generateFilePreview(inputFile);
                    tempUploadedFiles.push({url: url, message: message});
                }
                
                setGeneratedFiles(tempUploadedFiles);
            })();
        }
    }, [uploadedFiles]);

    return (
        <ImageSlider
            {...props}
            generatedFiles={generatedFiles}
            className={cssClass}
        />
    );
};

export { generateFilePreview };
